import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// ── Ressources de traduction (FR / EN / DE) ───────────────────
// Toutes les chaînes affichées sur le site public sont ici.
// Pour modifier un texte, change-le dans les 3 langues.

const resources = {
  fr: {
    translation: {
      nav: {
        home: "Accueil",
        story: "Notre histoire",
        whereWhen: "Où & Quand",
        gallery: "Galerie",
        events: "Événements",
        rsvp: "RSVP",
      },
      home: {
        invited: "Vous êtes invité(e)",
        cine1: "Chaque histoire d'amour est belle…",
        cine2: "mais la nôtre est notre préférée",
        name1: "Winnie",
        name2: "Donald",
        title1: "Nous allons",
        title2: "nous marier",
        date: "– 29 AOÛT 2026 –",
        rsvpCta: "Confirmer ma présence",
      },
      countdown: {
        title: "Le compte à rebours de notre toujours",
        subtitle:
          "Chaque battement de cœur, chaque lever de soleil, chaque instant qui passe nous rapproche du jour où nous célébrerons notre amour, entourés de ceux qui comptent le plus.",
        days: "Jours",
        hours: "Heures",
        minutes: "Minutes",
        seconds: "Secondes",
        quote:
          "L'amour ne se mesure pas au temps, mais chaque seconde jusqu'à notre « oui » est précieuse.",
        cta: "Confirmez votre présence",
        finale: "C'est aujourd'hui. Bienvenue au commencement de notre toujours.",
        surprise:
          "Merci de faire partie de l'un des plus beaux jours de notre vie.",
      },
      story: {
        headerPre: "Notre",
        headerPost: "Histoire",
        subtext:
          "Notre histoire a pris racine en Allemagne, dans l'effervescence d'une vie étudiante partagée.\n\nC'est à Gießen, à la fin de l'année 2019, que nos chemins se sont croisés pour la première fois. Donald en était à son deuxième semestre, moi je débutais tout juste le mien. Deux étudiants, un même établissement, rien de plus au départ. Mais la vie en a décidé autrement.\n\nAu fil des jours, nous avons appris à nous découvrir, à nous soutenir dans les moments simples comme dans les plus difficiles. Une belle amitié est née, discrètement et naturellement, avant de s'épanouir en quelque chose de bien plus grand.",
        footer: "Et aujourd'hui... nous allons nous marier !",
        item1Title: "Le début de tout",
        item1Text:
          "Ce qui semblait n'être qu'une rencontre ordinaire entre deux étudiants s'est révélé être le point de départ d'une véritable aventure. Doucement, sans qu'on s'y attende vraiment, un lien profond s'est tissé entre nous.",
        item2Title: "L'arrivée de notre fils",
        item2Text:
          "Le 28 août 2023, notre bonheur a pris un nouveau visage avec la naissance de notre fils. Sa venue a illuminé notre quotidien et changé notre façon de voir le monde. Il nous a apporté une joie immense.",
        item3Title: "Nos fiançailles",
        item3Text:
          "En 2024, nous avons franchi une nouvelle étape : nous nous sommes fiancés. Nous voulions continuer ce chemin ensemble.",
        item4Title: "Un nouveau chapitre",
        item4Text:
          "Après des années de bonheur partagé, de défis traversés et de souvenirs gravés dans nos cœurs, nous avons choisi d'écrire la plus belle page de notre histoire. C'est avec une joie immense et une profonde gratitude que nous avons décidé d'unir nos vies par le mariage. Nous sommes infiniment heureux de vivre ce moment unique, entourés de nos familles, de nos amis et de toutes les personnes qui comptent pour nous.",
      },
      whereWhen: {
        titlePre: "Quand &",
        titleEm: "Où",
        subtext:
          "Rejoignez-nous pour célébrer notre union dans la joie et l'amour. Nous serions honorés de partager ce moment inoubliable avec vous à Gießen, en Allemagne.",
        infoDate: "28 & 29 Août 2026",
        infoTime: "Mariage civil & Réception",
        infoPlace: "Danemark & Allemagne",
        cardDate: "Date",
        cardEvent: "Programme",
        cardPlace: "Lieux",
        journey:
          "Deux pays, une seule célébration. Un seul amour, un voyage inoubliable.",
        ceremonyIcon: "M",
        ceremonyTitle: "Mariage civil",
        ceremonyIntro:
          "Notre mariage civil aura lieu le 28 août 2026 à 11h00, au Danemark :",
        ceremonyOutro:
          "C'est ce jour-là que notre union sera officiellement scellée.",
        receptionIcon: "C",
        receptionTitle: "Célébration & Réception",
        receptionIntro:
          "Le lendemain, le 29 août 2026 de 17h00 à 22h30, nous célébrons avec vous en Allemagne :",
        receptionOutro:
          "Un repas et une soirée festive vous attendent pour célébrer ce moment unique. Nous vous prions d'être présents à 16h30 précises et vous remercions par avance pour votre ponctualité.",
        attendingTitle: "Serez-vous présent(e) ?",
        attendingText:
          "Votre présence est notre plus beau cadeau. Merci de nous confirmer votre participation avant le 5 juillet 2026 afin que nous puissions organiser au mieux cette journée spéciale.",
      },
      gallery: {
        titlePre: "Notre",
        titlePost: "Galerie",
        subtext:
          "Quelques moments précieux capturés au fil de notre histoire, des souvenirs qui racontent notre amour et notre chemin parcouru ensemble jusqu'à ce grand jour.",
      },
      couple: {
        nickname: "- surnom -",
      },
      footer: {
        line1: "Merci",
        line2: "à vous",
        thankTitle: "Merci de faire partie de notre histoire",
        message:
          "Du fond du cœur, merci de partager ce chapitre inoubliable de nos vies. Votre amour, votre soutien et votre présence rendent cette célébration encore plus précieuse. Nous avons hâte de célébrer avec vous.",
        quote: "Chaque fin est le commencement de quelque chose de beau.",
        appreciation:
          "Nous sommes profondément honorés de célébrer ce jour si spécial avec vous. Votre présence est le plus beau des cadeaux.",
        dateLine: "29 août 2026 • Gießen, Allemagne",
        madeWith: "Fait avec ♥ pour Winnie & Donald",
        seeYou: "À très bientôt, le 29 août 2026",
        rights: "Tous droits réservés",
      },
      rsvp: {
        title: "RSVP",
        deadline: "5 juillet 2026",
        subtitle:
          "Merci de confirmer votre présence avant le {{date}}. Votre réponse nous aidera à organiser au mieux cette journée inoubliable et à préparer le plan de table.",
        success: "Merci ! Votre confirmation a bien été enregistrée. 🎉",
        errorRequired: "Merci de remplir tous les champs obligatoires.",
        errorGeneric: "Une erreur est survenue. Veuillez réessayer.",
        nameLabel: "Prénom et nom *",
        attendLabel: "Je serai présent(e) à *",
        attendCeremony: "La Cérémonie",
        attendReception: "La Réception",
        attendBoth: "La Cérémonie & La Réception",
        attendAbsent: "Je ne pourrai pas venir",
        guestQuestion: "Venez-vous accompagné(e) ?",
        yes: "Oui",
        no: "Non",
        guestNameLabel: "Prénom et nom de l'accompagnant(e) *",
        messageLabel: "Votre message pour les mariés",
        submit: "ENVOYER",
        successTitle: "Merci !",
        successBody:
          "Votre confirmation a bien été reçue. Nous sommes profondément honorés que vous célébriez avec nous cette journée inoubliable.",
        closing:
          "Votre présence est le plus beau cadeau que nous puissions recevoir. Nous avons hâte de célébrer ce jour inoubliable à vos côtés.",
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        story: "Story",
        whereWhen: "Where & When",
        gallery: "Gallery",
        events: "Events",
        rsvp: "RSVP",
      },
      home: {
        invited: "You're Invited",
        cine1: "Every love story is beautiful…",
        cine2: "but ours is our favorite",
        name1: "Winnie",
        name2: "Donald",
        title1: "We Are Getting",
        title2: "Married",
        date: "– AUGUST 29TH, 2026 –",
        rsvpCta: "Confirm My Attendance",
      },
      countdown: {
        title: "The countdown to our forever",
        subtitle:
          "Every heartbeat, every sunrise, and every passing moment brings us closer to celebrating our love with the people who matter most.",
        days: "Days",
        hours: "Hours",
        minutes: "Minutes",
        seconds: "Seconds",
        quote:
          "Love is not measured by time, but every second until we say ‘I do’ is precious.",
        cta: "Confirm your attendance",
        finale: "Today is the day. Welcome to the beginning of our forever.",
        surprise:
          "Thank you for being part of one of the most important days of our lives.",
      },
      story: {
        headerPre: "Our",
        headerPost: "Story",
        subtext:
          "Our story took root in Germany, in the excitement of a shared student life.\n\nIt was in Gießen, at the end of 2019, that our paths first crossed. Donald was in his second semester, while I was just beginning mine. Two students, one same institution, nothing more at first. But life had other plans.\n\nDay after day, we learned to discover each other, to support one another through the simple moments and the harder ones alike. A beautiful friendship was born, quietly and naturally, before blossoming into something far greater.",
        footer: "And today... we're getting married!",
        item1Title: "Where It All Began",
        item1Text:
          "What seemed like an ordinary meeting between two students turned out to be the start of a real adventure. Slowly, almost without realising it, a deep bond grew between us.",
        item2Title: "The Arrival of Our Son",
        item2Text:
          "On August 28, 2023, our happiness took on a new face with the birth of our son. His arrival lit up our daily life and changed the way we see the world. He brought us immense joy.",
        item3Title: "Our Engagement",
        item3Text:
          "In 2024, we took a new step: we got engaged. We wanted to keep walking this path together.",
        item4Title: "A New Chapter",
        item4Text:
          "After years of shared happiness, of challenges overcome and memories engraved in our hearts, we have chosen to write the most beautiful page of our story. It is with immense joy and deep gratitude that we have decided to unite our lives in marriage. We are infinitely happy to share this unique moment surrounded by our families, our friends and everyone who matters to us.",
      },
      whereWhen: {
        titlePre: "When &",
        titleEm: "Where",
        subtext:
          "Join us to celebrate our union in joy and love. We would be honored to share this unforgettable moment with you in Gießen, Germany.",
        infoDate: "August 28 & 29, 2026",
        infoTime: "Civil wedding & Reception",
        infoPlace: "Denmark & Germany",
        cardDate: "Date",
        cardEvent: "Programme",
        cardPlace: "Where",
        journey:
          "Two countries, one celebration. One love, one unforgettable journey.",
        ceremonyIcon: "C",
        ceremonyTitle: "Civil Wedding",
        ceremonyIntro:
          "Our civil wedding will take place on August 28, 2026 at 11:00 AM, in Denmark:",
        ceremonyOutro:
          "This is the day our union will be officially sealed.",
        receptionIcon: "C",
        receptionTitle: "Celebration & Reception",
        receptionIntro:
          "The next day, on August 29, 2026 from 5:00 PM to 10:30 PM, we celebrate with you in Germany:",
        receptionOutro:
          "A meal and a festive evening await you to celebrate this unique moment. Please arrive by 4:30 PM sharp — thank you in advance for your punctuality.",
        attendingTitle: "Are You Attending?",
        attendingText:
          "Your presence is our greatest gift. Please confirm your attendance before July 5, 2026 so that we can best organize this special day.",
      },
      gallery: {
        titlePre: "Our",
        titlePost: "Gallery",
        subtext:
          "A few precious moments captured throughout our story, memories that tell of our love and the journey we've shared together up to this big day.",
      },
      couple: {
        nickname: "- nickname -",
      },
      footer: {
        line1: "Thank",
        line2: "You",
        thankTitle: "Thank you for being part of our story",
        message:
          "From the bottom of our hearts, thank you for sharing this unforgettable chapter of our lives. Your love, your support, and your presence make this celebration even more meaningful. We cannot wait to celebrate with you.",
        quote: "Every ending is the beginning of something beautiful.",
        appreciation:
          "We are truly honored to celebrate this special day with you. Your presence is the greatest gift we could receive.",
        dateLine: "August 29, 2026 • Gießen, Germany",
        madeWith: "Made with ♥ for Winnie & Donald",
        seeYou: "See you on August 29, 2026",
        rights: "All rights reserved",
      },
      rsvp: {
        title: "RSVP",
        deadline: "July 5, 2026",
        subtitle:
          "Please confirm your attendance before {{date}}. Your response will help us best organize this unforgettable day and prepare the seating plan.",
        success: "Thank you! Your confirmation has been saved. 🎉",
        errorRequired: "Please fill in all required fields.",
        errorGeneric: "An error occurred. Please try again.",
        nameLabel: "First and last name *",
        attendLabel: "I will attend *",
        attendCeremony: "The Ceremony",
        attendReception: "The Reception",
        attendBoth: "The Ceremony & Reception",
        attendAbsent: "I won't be able to come",
        guestQuestion: "Are you bringing a guest?",
        yes: "Yes",
        no: "No",
        guestNameLabel: "Guest's first and last name *",
        messageLabel: "Your message for the couple",
        submit: "SEND",
        successTitle: "Thank You",
        successBody:
          "Your RSVP has been received. We are truly honored that you will celebrate this unforgettable day with us.",
        closing:
          "Your presence is the greatest gift we could receive. We cannot wait to celebrate this unforgettable day with you.",
      },
    },
  },
  de: {
    translation: {
      nav: {
        home: "Startseite",
        story: "Geschichte",
        whereWhen: "Wo & Wann",
        gallery: "Galerie",
        events: "Programm",
        rsvp: "RSVP",
      },
      home: {
        invited: "Sie sind eingeladen",
        cine1: "Jede Liebesgeschichte ist schön…",
        cine2: "doch unsere ist unsere liebste",
        name1: "Winnie",
        name2: "Donald",
        title1: "Wir werden",
        title2: "heiraten",
        date: "– 29. AUGUST 2026 –",
        rsvpCta: "Teilnahme bestätigen",
      },
      countdown: {
        title: "Der Countdown zu unserem Für-immer",
        subtitle:
          "Jeder Herzschlag, jeder Sonnenaufgang und jeder vergehende Augenblick bringt uns dem Tag näher, an dem wir unsere Liebe mit den wichtigsten Menschen feiern.",
        days: "Tage",
        hours: "Stunden",
        minutes: "Minuten",
        seconds: "Sekunden",
        quote:
          "Liebe misst sich nicht an der Zeit, doch jede Sekunde bis zu unserem Ja ist kostbar.",
        cta: "Bestätigen Sie Ihre Teilnahme",
        finale: "Heute ist der Tag. Willkommen zum Beginn unseres Für-immer.",
        surprise:
          "Danke, dass Sie Teil eines der wichtigsten Tage unseres Lebens sind.",
      },
      story: {
        headerPre: "Unsere",
        headerPost: "Geschichte",
        subtext:
          "Unsere Geschichte hat in Deutschland Wurzeln geschlagen, mitten im bewegten Leben gemeinsamer Studienjahre.\n\nIn Gießen, Ende 2019, kreuzten sich unsere Wege zum ersten Mal. Donald war in seinem zweiten Semester, ich begann gerade mein erstes. Zwei Studierende, dieselbe Hochschule, mehr war es anfangs nicht. Doch das Leben hatte andere Pläne.\n\nTag für Tag lernten wir, einander zu entdecken und uns in den einfachen wie in den schwierigen Momenten beizustehen. Leise und ganz natürlich entstand eine schöne Freundschaft, bevor sie zu etwas viel Größerem aufblühte.",
        footer: "Und heute... heiraten wir!",
        item1Title: "Wo alles begann",
        item1Text:
          "Was wie eine gewöhnliche Begegnung zwischen zwei Studierenden schien, wurde zum Beginn eines echten Abenteuers. Ganz langsam, fast unbemerkt, wuchs eine tiefe Verbindung zwischen uns.",
        item2Title: "Die Ankunft unseres Sohnes",
        item2Text:
          "Am 28. August 2023 bekam unser Glück mit der Geburt unseres Sohnes ein neues Gesicht. Seine Ankunft erhellte unseren Alltag und veränderte unseren Blick auf die Welt. Er schenkte uns eine unendliche Freude.",
        item3Title: "Unsere Verlobung",
        item3Text:
          "2024 gingen wir einen neuen Schritt: Wir haben uns verlobt. Wir wollten diesen Weg gemeinsam weitergehen.",
        item4Title: "Ein neues Kapitel",
        item4Text:
          "Nach Jahren voller gemeinsamem Glück, gemeisterter Herausforderungen und tief in unseren Herzen verankerter Erinnerungen haben wir uns entschieden, die schönste Seite unserer Geschichte zu schreiben. Mit unendlicher Freude und tiefer Dankbarkeit haben wir beschlossen, unser Leben in der Ehe zu vereinen. Wir sind überglücklich, diesen einzigartigen Moment im Kreise unserer Familien, Freunde und aller Menschen zu erleben, die uns am Herzen liegen.",
      },
      whereWhen: {
        titlePre: "Wann &",
        titleEm: "Wo",
        subtext:
          "Feiern Sie mit uns unsere Vereinigung in Freude und Liebe. Es wäre uns eine Ehre, diesen unvergesslichen Moment mit Ihnen in Gießen, Deutschland, zu teilen.",
        infoDate: "28. & 29. August 2026",
        infoTime: "Standesamt & Empfang",
        infoPlace: "Dänemark & Deutschland",
        cardDate: "Datum",
        cardEvent: "Programm",
        cardPlace: "Orte",
        journey:
          "Zwei Länder, eine Feier. Eine Liebe, eine unvergessliche Reise.",
        ceremonyIcon: "S",
        ceremonyTitle: "Standesamtliche Trauung",
        ceremonyIntro:
          "Unsere standesamtliche Trauung findet am 28. August 2026 um 11:00 Uhr in Dänemark statt:",
        ceremonyOutro:
          "An diesem Tag wird unsere Verbindung offiziell besiegelt.",
        receptionIcon: "F",
        receptionTitle: "Feier & Empfang",
        receptionIntro:
          "Am nächsten Tag, dem 29. August 2026 von 17:00 bis 22:30 Uhr, feiern wir mit Ihnen in Deutschland:",
        receptionOutro:
          "Ein Essen und ein festlicher Abend erwarten Sie, um diesen einzigartigen Moment zu feiern. Wir bitten Sie, pünktlich um 16:30 Uhr da zu sein, und danken Ihnen im Voraus für Ihre Pünktlichkeit.",
        attendingTitle: "Sind Sie dabei?",
        attendingText:
          "Ihre Anwesenheit ist unser schönstes Geschenk. Bitte bestätigen Sie Ihre Teilnahme bis zum 5. Juli 2026, damit wir diesen besonderen Tag bestmöglich planen können.",
      },
      gallery: {
        titlePre: "Unsere",
        titlePost: "Galerie",
        subtext:
          "Einige kostbare Momente, die im Laufe unserer Geschichte festgehalten wurden, Erinnerungen, die von unserer Liebe und unserem gemeinsamen Weg bis zu diesem großen Tag erzählen.",
      },
      couple: {
        nickname: "- Spitzname -",
      },
      footer: {
        line1: "Vielen",
        line2: "Dank",
        thankTitle: "Danke, dass Sie Teil unserer Geschichte sind",
        message:
          "Aus tiefstem Herzen danken wir Ihnen, dass Sie dieses unvergessliche Kapitel unseres Lebens mit uns teilen. Ihre Liebe, Ihre Unterstützung und Ihre Anwesenheit machen diese Feier noch wertvoller. Wir können es kaum erwarten, mit Ihnen zu feiern.",
        quote: "Jedes Ende ist der Anfang von etwas Schönem.",
        appreciation:
          "Es ist uns eine große Ehre, diesen besonderen Tag mit Ihnen zu feiern. Ihre Anwesenheit ist das schönste Geschenk.",
        dateLine: "29. August 2026 • Gießen, Deutschland",
        madeWith: "Mit ♥ gemacht für Winnie & Donald",
        seeYou: "Bis bald, am 29. August 2026",
        rights: "Alle Rechte vorbehalten",
      },
      rsvp: {
        title: "RSVP",
        deadline: "5. Juli 2026",
        subtitle:
          "Bitte bestätigen Sie Ihre Teilnahme bis zum {{date}}. Ihre Antwort hilft uns, diesen unvergesslichen Tag bestmöglich zu organisieren und die Sitzordnung vorzubereiten.",
        success: "Danke! Ihre Zusage wurde gespeichert. 🎉",
        errorRequired: "Bitte füllen Sie alle Pflichtfelder aus.",
        errorGeneric: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
        nameLabel: "Vor- und Nachname *",
        attendLabel: "Ich nehme teil an *",
        attendCeremony: "Der Trauung",
        attendReception: "Dem Empfang",
        attendBoth: "Trauung & Empfang",
        attendAbsent: "Ich kann leider nicht kommen",
        guestQuestion: "Kommen Sie in Begleitung?",
        yes: "Ja",
        no: "Nein",
        guestNameLabel: "Vor- und Nachname der Begleitung *",
        messageLabel: "Ihre Nachricht an das Brautpaar",
        submit: "SENDEN",
        successTitle: "Danke!",
        successBody:
          "Ihre Zusage ist bei uns eingegangen. Es ist uns eine große Ehre, dass Sie diesen unvergesslichen Tag mit uns feiern.",
        closing:
          "Ihre Anwesenheit ist das schönste Geschenk, das wir uns wünschen können. Wir freuen uns darauf, diesen unvergesslichen Tag mit Ihnen zu feiern.",
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr", // langue par défaut si la détection échoue
    supportedLngs: ["fr", "en", "de"],
    interpolation: { escapeValue: false }, // React échappe déjà
    detection: {
      // priorité : choix mémorisé > langue du navigateur
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
  });

export default i18n;
